import { render, staticRenderFns } from "./top-message.vue?vue&type=template&id=407fd4c3&scoped=true"
import script from "./top-message.vue?vue&type=script&lang=ts"
export * from "./top-message.vue?vue&type=script&lang=ts"
import style0 from "./top-message.vue?vue&type=style&index=0&id=407fd4c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407fd4c3",
  null
  
)

export default component.exports